import React from 'react';

const SkeletonCard = () => {
  return (
    <div className="animate-pulse bg-white shadow rounded p-2">
      <div className="bg-gray-200 h-48 w-full rounded mb-4"></div>
      <div className="h-4 bg-gray-200 rounded mb-2 w-3/4"></div>
      <div className="h-4 bg-gray-200 rounded mb-2 w-1/2"></div>
      <div className="h-4 bg-gray-200 rounded mb-4 w-2/3"></div>
      <div className="h-8 bg-gray-300 rounded w-full"></div>
    </div>
  );
};

export default SkeletonCard;
